import React from "react";
import { Input, Row, Typography, Form, Col, Divider, Select, DatePicker } from "antd";
import { labelConfig } from "../../../glAndAccounting.config";
import appLabel from "../../../../../config/appLabel";
import { BOM } from "../../../../../services/definedMethod";
const { Title, Text } = Typography;

const OverviewForm = (props) => {
  const {
    onFinish,
    form,
    formData,
    glCodeLength,
    templateData,
    parentData,
    tagData,
    accountTypeData,
  } = props;
  console.log(templateData, "templateDatatemplateData");
  console.log(parentData, "parentDataparentData");
  console.log(tagData, "tagDatatagData");
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      {/* <Row> */}
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.glOverview}
        </Title>
      </Divider>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="type"
            label={<Text strong>{appLabel.accountType}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(appLabel.accountType),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(appLabel.accountType)}
              showSearch
              options={accountTypeData}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="glCode"
            label={<Text strong>{appLabel.GLCode}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(appLabel.GLCode),
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  if (value.length < glCodeLength) {
                    return Promise.reject(
                      new Error(`GL Code must be ${glCodeLength} characters long`),
                    );
                  }

                  if (value.length > glCodeLength) {
                    return Promise.reject(
                      new Error(`Value must not exceed ${glCodeLength} characters`),
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(appLabel.GLCode)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="name"
            label={<Text strong>{labelConfig.glName}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.glName),
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.glName)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="shortName"
            label={<Text strong>{appLabel.shortName}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(appLabel.shortName),
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(appLabel.shortName)} />
          </Form.Item>
        </Col>
        {/* </Row> */}
        {/* <Row> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="category"
            label={<Text strong>{appLabel.category}</Text>}
            // rules={[
            //   {
            //     required: true,
            //     message: "This field is required",
            //   },
            // ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(appLabel.category)}
              showSearch
              options={parentData}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              key={templateData.selectedAccountType} // Force re-render when account type changes
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="accountLevel"
            label={<Text strong>{labelConfig.accountLevel}</Text>}
            // rules={[
            //   {
            //     required: true,
            //     message: "This field is required",
            //   },
            // ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.accountLevel)}
              showSearch
              options={templateData.accountLevelOptions}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              key={templateData.selectedAccountType} // Force re-render when account type changes
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="parentId"
            label={<Text strong>{appLabel.parent}</Text>}
            rules={[
              {
                required: true,
                message: "This field is required",
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(appLabel.parent)}
              showSearch
              options={parentData}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              key={templateData.selectedAccountType} // Force re-render when account type changes
            />
          </Form.Item>
        </Col>
        {/* </Row>
      <Row> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="accountStatus"
            label={<Text strong>{labelConfig.accountStatus}</Text>}
            // rules={[
            //   {
            //     required: true,
            //     message: "This field is required",
            //   },
            // ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.accountStatus)}
              showSearch
              options={templateData.accountStatusOptions}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              key={templateData.selectedAccountType} // Force re-render when account type changes
            />
          </Form.Item>
        </Col>

        {/* </Row> */}
        {/* <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.accountClassification}
          </Title>
        </Divider> */}
        {/* <Row> */}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="naturalBalance"
            label={<Text strong>{labelConfig.naturalBalance}</Text>}
            rules={[
              {
                required: true,
                message: "This field is required",
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.naturalBalance)}
              showSearch
              options={templateData.naturalBalanceOptions}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              key={templateData.selectedAccountType} // Force re-render when account type changes
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="regulatoryReportingCode"
            label={<Text strong>{labelConfig.regulatoryReportingCode}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.regulatoryReportingCode),
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.regulatoryReportingCode)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="ifrsClassification"
            label={<Text strong>{labelConfig.ifrsClassification}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.ifrsClassification),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.ifrsClassification)}
              showSearch
              options={templateData.ifrsClassificationOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="taxCategory"
            label={<Text strong>{labelConfig.taxCategory}</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.taxCategory),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(labelConfig.taxCategory)}
              showSearch
              options={templateData.taxCategoryOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>{labelConfig.openingDate}</Text>}
            name={"approvedOnDate"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.openingDate),
              },
            ]}
          >
            <DatePicker
              disabledDate={BOM.DisabledAfterCurrentDate}
              style={{ width: "100%", height: 35 }}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>{labelConfig.closingDate}</Text>}
            name={"approvedOnDat"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.closingDate),
              },
            ]}
          >
            <DatePicker
              disabledDate={BOM.DisabledAfterCurrentDate}
              style={{ width: "100%", height: 35 }}
            />
          </Form.Item>
        </Col>
      </Row>
      {/* </Row> */}
      {/* </Row> */}
    </Form>
  );
};

export default OverviewForm;
